export default __webpack_public_path__ + "static/media/guaranteed-rate-logo-white.148dc40e.svg";